import { LANGUAGES } from '@/utils/constants'

export default {
  username: '',

  token: '',

  isVisitorAccess: false,

  survey: null,

  hasSurvey: false,

  messages: '',

  modalProperties: null,

  modalClone: null,

  toggleSurveyAdvancedSettingsModal: false,

  modalBtns: null,

  modalGroupsAdvancedSettings: null,

  modalMedia: null,

  modalTemplate: null,

  modalPreview: null,

  loginModal: {
    open: false,
    text: '',
  },

  loading: false,

  mediaObj: null,

  deleteMedia: null,

  modalFacialCoding: null,

  facialCodingObj: null,

  page: '',

  darkmode: JSON.parse(window.sessionStorage.getItem('darkmode')) || false,

  accType: '',

  firstAccess: false,

  groupName: '',

  rateCard: '',

  changeFlow: false,

  tabBilling: null,

  value: '',

  user: null,

  users: [],

  language: window.localStorage.getItem('language') || LANGUAGES.ENGLISH,

  chartType: 'bar',

  chartSettings: {},

  showConfig: {},

  reportQuestionsDownloadControl: {},

  surveyStatusWithChartConfig: {},

  // QUOTA VARIABLES

  step: 1,

  wantedCompletes: 0,

  basicQuestions: [],

  advancedQuestions: [],

  answers: [],

  quotaJSON: {},

  completeChecker: false,

  quotaOrder: [],

  country: [],

  projectCreated: false,

  loadingSaveSettingsQuota: false,

  // SCHEME VARIABLES

  matrixDisplay: null,

  matrixFilter: null,

  matrixFilterReverse: null,

  updatedAdvancedOptions: null,

  params: null,

  validSlider: null,

  loadSurvey: null,

  updateLog: null,

  preview: null,

  updateQuestions: null,

  groupNameChange: '',

  questionGroups: [],

  categories: {
    surveyName: '',
    lang: '',
    type: '',
    sid: 0,
  },

  sub: null,

  changeCode: null,

  uploaded: null,

  questionCodeValidation: false,
}
